import { useTranslation } from "react-i18next";
import { css } from "../../../styled-system/css";
import { token } from "../../../styled-system/tokens";
import { UploadStatus, getStatusLabel } from "./constants";

const STATUS_COLORS: Record<number, string> = {
  [UploadStatus.PENDING]: token("colors.gray.500"),
  [UploadStatus.VALIDATING]: token("colors.blue.600"),
  [UploadStatus.PROCESSING]: token("colors.blue.600"),
  [UploadStatus.VALIDATED]: token("colors.amber.500"),
  [UploadStatus.SUCCESS]: token("colors.green.600"),
  [UploadStatus.FAILED]: token("colors.red.600"),
  [UploadStatus.VALIDATION_FAILED]: token("colors.red.600"),
  [UploadStatus.CANCELLED]: token("colors.gray.400"),
};

export function StatusBadge({ status }: { status: number }) {
  const { t } = useTranslation(["uploads"]);
  const color = STATUS_COLORS[status] ?? token("colors.gray.500");
  return (
    <span
      className={css({
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: "full",
        fontSize: "small",
        fontWeight: "semibold",
        color: "white",
      })}
      style={{ backgroundColor: color }}
    >
      {t(getStatusLabel(status))}
    </span>
  );
}
